import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Header.css';
import { useLanguage } from './LanguageContext';

const Header: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();
  const [showStartOver, setShowStartOver] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkOnboardingState = () => {
      try {
        const savedState = sessionStorage.getItem('izypostOnboardingState');
        if (savedState) {
          const state = JSON.parse(savedState);
          setShowStartOver(!!state.isVerified);
        } else {
          setShowStartOver(false);
        }
      } catch (e) {
        setShowStartOver(false);
      }
    };

    checkOnboardingState(); // Initial check

    window.addEventListener('onboardingStateChange', checkOnboardingState);

    return () => {
      window.removeEventListener('onboardingStateChange', checkOnboardingState);
    };
  }, []); // Run only on mount

  const handleStartOver = () => {
    // Optional: Ask for confirmation
    if (window.confirm(t('startOverConfirmation'))) {
      localStorage.removeItem('izypostOnboardingForm');
      sessionStorage.removeItem('izypostOnboardingState');
      window.location.href = '/';
    }
  };

  return (
    <header className="site-header">
      <img src="/izyposlogo.png" alt="IZYPOS Logo" className="site-logo" />
      <div className="site-tagline">{t('tagline')}</div>
      <div className="header-actions">
        {showStartOver && (
          <button onClick={handleStartOver} className="start-over-btn">
            {t('startOver')}
          </button>
        )}
        <div className="lang-switcher">
          <button
            className={language === 'en-US' ? 'active' : ''}
            onClick={() => setLanguage('en-US')}
          >EN</button>
          <span className="lang-divider">|</span>
          <button
            className={language === 'fr-CA' ? 'active' : ''}
            onClick={() => setLanguage('fr-CA')}
          >FR</button>
        </div>
      </div>
    </header>
  );
};

export default Header; 